export default {
  campaigns: [],
  campaignCount: 0,
  filteredCampaigns: [],
  campaign: {}
}